import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("a", { to: "#" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Export to CSV")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("a", { to: "#" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Export to XML")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", { to: "#" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Export to Drive")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Content = _resolveComponent("Content")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createBlock(_component_a_dropdown, {
    "overlay-class-name": _ctx.className,
    placement: _ctx.placement,
    title: _ctx.title,
    trigger: _ctx.action
  }, {
    overlay: _withCtx(() => [
      _createVNode(_component_Content, null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "overlay", {}, () => [
            _hoisted_1,
            _hoisted_2,
            _hoisted_3
          ])
        ]),
        _: 3
      })
    ]),
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["overlay-class-name", "placement", "title", "trigger"]))
}